import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';

interface AgentTabHeaderProps {
  icon: LucideIcon;
  title: string;
  description: string;
  actions?: ReactNode;
}

export default function AgentTabHeader({
  icon: Icon,
  title,
  description,
  actions,
}: AgentTabHeaderProps) {
  return (
    <div className="sticky top-0 z-20 -mx-4 -mt-4 border-b bg-background/95 px-4 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/90">
      <div className="mx-auto flex w-full max-w-4xl flex-wrap items-center justify-between gap-x-6 gap-y-3">
        <div className="min-w-0 flex-1 basis-60">
          <h2 className="flex items-center gap-2 text-lg font-semibold tracking-tight">
            <Icon className="h-4 w-4 shrink-0 text-muted-foreground" strokeWidth={1.75} />
            {title}
          </h2>
          <p className="mt-0.5 text-sm leading-5 text-muted-foreground">
            {description}
          </p>
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
